import { HOST } from "common-import/constants";
import { observable, autorun } from "mobx";
import { Request, MobXHelper } from "common-import/helpers";
const { makePersit } = MobXHelper;

const PERSIST_STORE_ITEM = {
}

const SHEET_API = field => "https://script.google.com/macros/s/AKfycbz2mwvpAYUjvP4c4qF00czzBM86ZM0_-cnI6-WlvKHQh9gSbn8/exec?field="+field;

class Store {

  constructor() {
    this.loadInitialData();
  }

  @observable lang = "vi";

  @observable contractor_type = {};
  @observable contractor_company_type = {};
  @observable contractor_construction_type = {};
  @observable project_type = {};
  @observable project_sub_type = {};
  @observable project_state = {};
  @observable project_state_status = {};
  @observable project_work_type = {};
  @observable project_investment_type = {};
  @observable project_purpose = {};
  @observable project_budget = {};
  @observable project_construction_area = {};
  @observable project_land_area = {};

  loadInitialData = async () => {
    let contractor_type = await makePersit.persist("contractor_type", "object");
    if (contractor_type != undefined) this.contractor_type = contractor_type;
    else this.getTypeOfContractor();

    let contractor_company_type = await makePersit.persist("contractor_company_type", "object");
    if (contractor_company_type != undefined) this.contractor_company_type = contractor_company_type; 
    else this.getTypeOfCompany();

    let contractor_construction_type = await makePersit.persist("contractor_construction_type", "object");
    if (contractor_construction_type != undefined) this.contractor_construction_type = contractor_construction_type; 
    else this.getTypeOfConstruction();

    let project_type = await makePersit.persist("project_type", "object");
    if (project_type != undefined) this.project_type = project_type; 
    else this.getTypeOfProject();

    let project_sub_type = await makePersit.persist("project_sub_type", "object");
    if (project_sub_type != undefined) this.project_sub_type = project_sub_type; 
    else this.getSubTypeOfProject();

    let project_state = await makePersit.persist("project_state", "object");
    if (project_state != undefined) this.project_state = project_state; 
    else this.getStageOfProject();

    let project_state_status = await makePersit.persist("project_state_status", "object");
    if (project_state_status != undefined) this.project_state_status = project_state_status; 
    else this.getStatusOfProject();

    let project_work_type = await makePersit.persist("project_work_type", "object");
    if (project_work_type != undefined) this.project_work_type = project_work_type; 
    else this.getProjectWorkType();

    let project_investment_type = await makePersit.persist("project_investment_type", "object");
    if (project_investment_type != undefined) this.project_investment_type = project_investment_type; 
    else this.getProjectInvestmentType();

    let project_purpose = await makePersit.persist("project_purpose", "object");
    if (project_purpose != undefined) this.project_purpose = project_purpose; 
    else this.getProjectPurpose();

    let project_budget = await makePersit.persist("project_budget", "object");
    if (project_budget != undefined) this.project_budget = project_budget; 
    else this.getProjectBudget();

    let project_construction_area = await makePersit.persist("project_construction_area", "object");
    if (project_construction_area != undefined) this.project_construction_area = project_construction_area; 
    else this.getProjectConstructionArea();

    let project_land_area = await makePersit.persist("project_land_area", "object");
    if (project_land_area != undefined) this.project_land_area = project_land_area; 
    else this.getProjectLandArea();
  }

  findID = (fieldObject, fieldValue) => {
    let dataVi = fieldObject.vi;
    let dataEn = fieldObject.en;
    let idArr = Object.keys(fieldObject.en);
    let length = idArr.length;
    for (let i=0; i<length; i++) {
      if(dataVi[idArr[i]] == fieldValue || dataEn[idArr[i]] == fieldValue) {
        return idArr[i];
      }
    }
    return -1;
  }

  toSelectData = (fieldObject) => {
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    let result = [];
    return Object.keys(data).map(item => ({ value: fieldObject.en[item], title: data[item] }));
  }

  toSelectDataWithFilter = (firstDotId) => (fieldObject) => { // like "1.1", "1.2", filter all "1.*"
    if(!fieldObject[this.lang]) return [];
    let data = fieldObject[this.lang];
    return Object.keys(data).filter(item => item.indexOf(firstDotId) === 0).map(item => ({ value: fieldObject.en[item], title: data[item] }));
  }

  getTypeOfContractor = async () => {
    let res = await fetch(SHEET_API("contractor_type"));
    let json = await res.json();
    this.contractor_type = json;
    makePersit.make(this.contractor_type, "contractor_type");
  }

  getTypeOfCompany = async () => {
    let res = await fetch(SHEET_API("contractor_company_type"));
    let json = await res.json();
    this.contractor_company_type = json;
    makePersit.make(this.contractor_company_type, "contractor_company_type");
  }

  getTypeOfConstruction = async () => {
    let res = await fetch(SHEET_API("contractor_construction_type"));
    let json = await res.json();
    this.contractor_construction_type = json;
    makePersit.make(this.contractor_construction_type, "contractor_construction_type");
  }

  getTypeOfProject = async () => {
    let res = await fetch(SHEET_API("project_type"));
    let json = await res.json();
    this.project_type = json;
    makePersit.make(this.project_type, "project_type");
  }

  getSubTypeOfProject = async () => {
    let res = await fetch(SHEET_API("project_sub_type"));
    let json = await res.json();
    this.project_sub_type = json;
    makePersit.make(this.project_sub_type, "project_sub_type");
  }

  getStageOfProject = async () => {
    let res = await fetch(SHEET_API("project_state"));
    let json = await res.json();
    this.project_state = json;
    makePersit.make(this.project_state, "project_state");
  }

  getStatusOfProject = async () => {
    let res = await fetch(SHEET_API("project_state_status"));
    let json = await res.json();
    this.project_state_status = json;
    makePersit.make(this.project_state_status, "project_state_status");
  }

  getProjectWorkType = async () => {
    let res = await fetch(SHEET_API("project_work_type"));
    let json = await res.json();
    this.project_work_type = json;
    makePersit.make(this.project_work_type, "project_work_type");
  }

  getProjectInvestmentType = async () => {
    let res = await fetch(SHEET_API("project_investment_type"));
    let json = await res.json();
    this.project_investment_type = json;
    makePersit.make(this.project_investment_type, "project_investment_type");
  }

  getProjectPurpose = async () => {
    let res = await fetch(SHEET_API("project_purpose"));
    let json = await res.json();
    this.project_purpose = json;
    makePersit.make(this.project_purpose, "project_purpose");
  }

  getProjectBudget = async () => {
    let res = await fetch(SHEET_API("project_budget"));
    let json = await res.json();
    this.project_budget = json;
    makePersit.make(this.project_budget, "project_budget");
  }

  getProjectConstructionArea = async () => {
    let res = await fetch(SHEET_API("project_construction_area"));
    let json = await res.json();
    this.project_construction_area = json;
    makePersit.make(this.project_construction_area, "project_construction_area");
  }

  getProjectLandArea = async () => {
    let res = await fetch(SHEET_API("project_land_area"));
    let json = await res.json();
    this.project_land_area = json;
    makePersit.make(this.project_land_area, "project_land_area");
  }
  
}

export default new Store();


// WEBPACK FOOTER //
// ./src/services/fieldMasterData/fieldMasterData.Store.js